
import {FETCHING_EXTRANET_URL, FETCH_EXTRANET_URL_SUCCESS, FETCH_EXTRANET_URL_FAIL} from "../actions/WolfConnectActions";

export default function reducer(
  state = {
    isFetching: false,
    fetched: false,
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCHING_EXTRANET_URL: {
      return { ...state, isFetching: true, fetched: false };
    }
    case FETCH_EXTRANET_URL_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        fetched: true,
        error: null
      };
    }
    case FETCH_EXTRANET_URL_FAIL: {
      return {
        ...state,
        isFetching: false,
        fetched: false,
        error: action.payload
      };
    }


    default:
      break;
  }

  return state;
}
